import {
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_FAILURE,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTION_DETAIL,
  FETCH_TRANSACTION_DETAIL_FAILURE,
  FETCH_TRANSACTION_DETAIL_SUCCESS,
  RESET_PAYMENT_DETAIL_STATE,
  RESET_PAYMENT_HISTORY_STATE,
  SET_GROUPED_TRANSACTIONS,
  UPDATE_SELECTED_TRANSACTION,
} from './constants';

export function fetchTransactions() {
  return { type: FETCH_TRANSACTIONS };
}

export function fetchTransactionsFailure(error) {
  return {
    payload: { error },
    type: FETCH_TRANSACTIONS_FAILURE,
  };
}

export function fetchTransactionsSuccess(page, totalPages, transactions) {
  return {
    payload: { page, totalPages, transactions },
    type: FETCH_TRANSACTIONS_SUCCESS,
  };
}

export function fetchTransactionDetail(transactionId) {
  return {
    payload: { transactionId },
    type: FETCH_TRANSACTION_DETAIL,
  };
}

export function fetchTransactionDetailFailure(error) {
  return {
    payload: { error },
    type: FETCH_TRANSACTION_DETAIL_FAILURE,
  };
}

export function fetchTransactionDetailSuccess(transaction) {
  return {
    payload: { transaction },
    type: FETCH_TRANSACTION_DETAIL_SUCCESS,
  };
}

export function resetPaymentDetailState() {
  return { type: RESET_PAYMENT_DETAIL_STATE };
}

export function resetPaymentHistoryState() {
  return { type: RESET_PAYMENT_HISTORY_STATE };
}

export function setGroupedTransactions(groupedTransactions) {
  return {
    payload: { groupedTransactions },
    type: SET_GROUPED_TRANSACTIONS,
  };
}

export function updateSelectedTransaction(id) {
  return {
    payload: { id },
    type: UPDATE_SELECTED_TRANSACTION,
  };
}
